import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetSaleOrderFileApi,
  GetSalesOrderDataByID,
  GetSalesOrderPartsByID,
  PrintQuoteApi,
} from "../../api";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { Header } from "../../components";
import DateTimeField from "../../components/DateTimeField";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import CartListTable from "../../components/CartListTable";
import PosForm2 from "../../components/PosForm2";
import { showErrorToast } from "../../components/ToastMesg";
import AttachFileOrder from "../../components/AttachFileOrder";

const ViewQuotation = () => {
  const navigate = useNavigate();
  let param = useParams();
  var so_id = param.so_id;
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
  } = useStateContext();
  const [CartList, setCartList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [store_id, setStore_id] = useState(0);
  const [oDatetime, setODatetime] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const [formData, setFormData] = useState({
    customer: "select",
    customer_po: "",
    sales_rep: "",
    terms: "select",
    ship_method: "select",
    account: "select",
    b_to: "",
    b_street: "",
    b_city: "",
    b_state: "",
    b_zip: "",
    b_country: "",
    b_phone2: "",
    s_to: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: "",
    s_phone: "",
    discount_label: "Discount",
    amount_paid: 0,
    amount_pending: 0,
    total_discount: 0,
    sub_total: 0,
    total_items: 0,
    grand_total: 0,
    tax: 0,
    shipping: 0,
    note: "",
    user_note: "",
    status: "select",
  });

  const handleToggle = (value) => {
    if (value.part_id) {
      TimeoutUtility.resetTimeout();
      setActiveProdMenuId({ part_id: value.part_id, store_id: store_id });
      setActiveProdMenu(true);
    }
  };

  const downloadFile = async (id) => {
    const resp = await GetSaleOrderFileApi(id);
    if (!resp) showErrorToast("Error!", "File not found!");
  };

  const handleSalesOrderClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate(`/Quotes/EditQuotation/${so_id}`);
  };

  const handlePrintOrderClick = async (e) => {
    if (window.confirm(`Do you want to show the price of this Quote?`)) {
      const resp = await PrintQuoteApi(so_id, true);
      if (!resp) showErrorToast("Error!", "Record not found!");
    } else {
      const resp = await PrintQuoteApi(so_id, false);
      if (!resp) showErrorToast("Error!", "Record not found!");
    }
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (!so_id) return;
      setloading(true);
      trackPromise(
        Promise.all([
          GetSalesOrderDataByID(so_id),
          GetSalesOrderPartsByID(so_id),
        ])
          .then(([res, partRes]) => {
            setODatetime(res.data.quote_date.slice(0, -1));
            setStore_id(res.data.store_id);
            let totalAmt = 0,
              totalItm = 0;
            if (partRes.data && partRes.data.length > 0) {
              const partList = partRes.data.map((item) => {
                totalAmt +=
                  parseFloat(item.price) * parseFloat(item.quantity) || 0;
                totalItm += parseFloat(item.quantity) || 0;
                return {
                  part_id: item.non_part ? null : item.part_id,
                  name: `${item.part_number} - ${item.part_description}`,
                  part_number: item.part_number || "",
                  details: item.part_description || "",
                  unit_price: item.price || 0,
                  unit: item.unit || "-",
                  cost_price: item.cost_price || 0,
                  quantity: item.quantity || 0,
                  discount: 0,
                  total:
                    parseFloat(item.price) * parseFloat(item.quantity) || 0,
                  shipment: 0,
                  image: null,
                  req_date: item.req_date ? item.req_date.split("T")[0] : "",
                  ship_date: "",
                  notes: item.item_note || "",
                };
              });
              setCartList(() => [...partList]);
            }
            const fileList = [];
            for (let i = 0; i < res.data.file_ids?.length; i++) {
              fileList.push({
                id: res.data.file_ids[i],
                file: null,
                name: res.data.file_names[i],
                size: 0,
                base64: null,
                note: "",
              });
            }
            setSelectedFiles(fileList);
            setFormData((prev) => ({
              ...prev,
              customer: {
                label: res.data.customer,
                value: res.data.customer_id,
              },
              customer_po: res.data.customer_po_no || "",
              sales_rep: res.data.sales_rep || "",
              terms: res.data.term
                ? { label: res.data.term, value: res.data.term_id }
                : "select",
              ship_method: {
                label: res.data.ship_method,
                value: res.data.ship_method_id,
              },
              b_to: res.data.bill_to || "",
              b_street: res.data.b_street || "",
              b_city: res.data.b_city || "",
              b_state: res.data.b_state || "",
              b_zip: res.data.b_zip || "",
              b_country: res.data.b_country || "",
              b_phone2: res.data.b_phone1 || "",
              s_to: res.data.ship_to || "",
              s_street: res.data.s_street || "",
              s_city: res.data.s_city || "",
              s_state: res.data.s_state || "",
              s_zip: res.data.s_zip || "",
              s_country: res.data.s_country || "",
              s_phone: res.data.s_phone || "",
              amount_paid: res.data.amount_paid || 0,
              total_discount: res.data.discount || 0,
              tax: res.data.tax || 0,
              shipping: res.data.shipment || 0,
              sub_total: totalAmt,
              grand_total: res.data.total_price,
              total_items: totalItm,
              note: res.data.so_note || "",
              user_note: res.data.user_note || "",
              status: {
                label: res.data.so_status,
                value: res.data.so_status_id,
              },
            }));
          })
          .catch((err) => console.log(err.message))
          .finally(() => setloading(false)),
      );
    }
    fetchData();
  }, [so_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      {(loading || promiseInProgress) && (
        <div className="overlay-freeze">
          <LoadingIndicator />
        </div>
      )}
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={5} className="container-col">
            <Header title="VIEW QUOTATION" />
          </Col>
          <Col md={2} className="container-col">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Q # {so_id}
            </label>
          </Col>
          <Col md={2} className="container-col">
            <DateTimeField
              label="DateTime:"
              name="quote_date"
              value={oDatetime}
              placeholder="DateTime"
              now={false}
              disabled
              style={{ width: "178px" }}
            />
          </Col>
          <Col md={3} className="container-col text-center">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Order Status: {formData.status.label}
            </label>
          </Col>
        </Row>
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={9} className="container-col">
            <div className="card-sale">
              <PosForm2
                formData={formData}
                currentColor={currentColor}
                type="quote"
                viewOnly={true}
              />
              <Row className="table-container-sale03">
                <CartListTable
                  CartList={CartList}
                  imagePerm={defaultImageMode && imageMode}
                  type="quote"
                  handleToggle={handleToggle}
                  viewOnly={true}
                  loading={promiseInProgress || loading}
                />
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row xs={1} sm={1} className="justify-content-center p-0">
                <Col md={6} className="container-col left-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handleSalesOrderClick}
                  >
                    <div className="action-btn">EDIT</div>
                  </Card>
                </Col>
                <Col md={6} className="container-col right-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
                <Col md={6} className="container-col right-table-field">
                  <label>Sales Rep:</label>
                  <input
                    name="sales_rep"
                    placeholder="Sales Rep"
                    value={formData.sales_rep}
                    disabled
                    className="input"
                  />
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Ship Method:</label>
                  <input
                    name="ship_method"
                    value={formData.ship_method.label || `-`}
                    placeholder="Select Ship Method"
                    disabled
                    className="input"
                  />
                </Col>
                <Col md={12} className="container-col right-table-field">
                  <label>Order Notes:</label>
                  <textarea
                    placeholder="Order Notes"
                    name="note"
                    value={formData.note}
                    disabled
                    className="textarea"
                  />
                </Col>
                <Col md={12} className="container-col right-table-field">
                  <label>User Notes:</label>
                  <textarea
                    placeholder="User Notes"
                    name="user_note"
                    value={formData.user_note}
                    disabled
                    className="textarea"
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center mt-2 pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Sub Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.sub_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  {formData.discount_label}:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.total_discount)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Tax:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {`${formData.tax}%`}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Shipping:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.shipping)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Grand Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.grand_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Total Items:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formData.total_items || 0}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 pt-2">
                <AttachFileOrder
                  selectedFiles={selectedFiles}
                  currentColor={currentColor}
                  loading={promiseInProgress || loading}
                  downloadFile={downloadFile}
                  viewOnly={true}
                />
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ViewQuotation;
